import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let KlookTransition = class KlookTransition extends Vue {
};
KlookTransition = __decorate([
    Component
], KlookTransition);
export default KlookTransition;
